import { i18n } from "@/plugins/i18n";
import { TableFieldType, TableHeader } from "helix-vue-components";

export const PriceGroupsTableMetadata: TableHeader[] = [
  {
    value: "name",
    label: i18n.t("price_groups.name").toString(),
    fieldComponent: TableFieldType.string,
    class: "tdt__headers__fieldLong",
    sortable: true
  }
];
